import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=c8d1203e&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\JH\\workspace\\r-UXDB4MFGGPNCQDCDVDHZHNGFNLKBT4K2FS26AFERI7RXVKAFNI2A\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8d1203e')) {
      api.createRecord('c8d1203e', component.options)
    } else {
      api.reload('c8d1203e', component.options)
    }
    module.hot.accept("./BasicLayout.vue?vue&type=template&id=c8d1203e&", function () {
      api.rerender('c8d1203e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "sources/series-display/themes/BasicLayout.vue"
export default component.exports